<template>
    <div class="ts-finder__resultlist">
        <pdf-download-button v-if="!isSearchMode" />
        <result-list-place v-for="(place, index) in places" :key="place.id" :place="place" v-on="$listeners" :preselected="preselectIndex == index" />
        <result-list-station v-for="(station, index) in sortedStations" :key="station.id" :station="station" :isSearchMode="isSearchMode" v-on="$listeners" :preselected="preselectIndex == index + totalPlaces" />
        <button @click="page++" v-show="hasMoreStations" class="ts-finder__resultlist-show-more" v-if="!isSearchMode">weitere Standorte <i class="fas fa-angle-down"></i></button>
    </div>
</template>

<script>
    import ResultListStation from './ResultListStation.vue'
    import ResultListPlace from './ResultListPlace.vue'
    import PdfDownloadButton from '../PdfDownloadButton.vue'
    import { mapState, mapActions } from 'vuex'

    export default {
        props: ['stations', 'places', 'isSearchMode'],
        data() {
            return {
                pageSize: 10,
                page: 1,
                sortedStations: [],
                hasMoreStations: false,
                preselectIndex: -1
            };
        },
        computed: {
            ...mapState([
                'strings',
                'selectedStation'
            ]),
            totalPlaces() {
                var numPlaces = 0;
                if (this.places)
                    numPlaces = this.places.length;
                return numPlaces;
            },
            totalStations() {
                var numStations = 0;
                if (this.sortedStations)
                    numStations = this.sortedStations.length;
                return numStations;
            },
            totalResults() {
                return this.totalPlaces + this.totalStations;
            }
        },
        watch: {
            stations() {
                this.page = 1;
                this.updateResultslist();
                this.initPreselectIndex();
            },
            places() {
                this.initPreselectIndex();
            },
            isSearchMode() {
                this.initPreselectIndex();
            },
            page() {
                this.updateResultslist();
                this.initPreselectIndex();
            }
        },
        beforeMount() {
            window.addEventListener('keyup', this.onKeyUp);
        },
        beforeDestroy() {
            window.removeEventListener('keyup', this.onKeyUp)
        },
        mounted() {
            //init the list
            this.updateResultslist();
            this.initPreselectIndex();
        },
        methods: {
            ...mapActions([
                'selectStation'
            ]),
            updateResultslist() {
                if (this.stations) {
                    //work with a copy of the stations array
                    let tempStations = [...this.stations];
                    //sort by distance (if available) or by name
                    tempStations.sort((x, y) => {
                        if (x.distance && y.distance) {
                            //compare by distance
                            return x.distance - y.distance;
                        } else {
                            //compare by name
                            return x.name.localeCompare(y.name);
                        }
                    });
                    //finally do the "paging" by only returning the desired amout of items
                    this.sortedStations = tempStations.slice(0, this.page * this.pageSize);

                    //show the "load more" link when there are more stations to show
                    this.hasMoreStations = this.stations.length > this.sortedStations.length;
                }
            },
            onKeyUp(e) {
                if (this.isSearchMode) {
                    if (e.keyCode == 38) { //up
                        if (this.preselectIndex > 0)
                            this.preselectIndex--;
                    } else if (e.keyCode == 40) { //down
                        if (this.preselectIndex < this.totalResults - 1)
                            this.preselectIndex++;
                    } else if (e.keyCode == 13) { //enter
                        if (this.preselectIndex > -1) {
                            if (this.preselectIndex < this.totalPlaces) { //a place was selected
                                let place = this.places[this.preselectIndex];
                                this.$emit('place-selected', place.place_id);
                            } else if (this.preselectIndex - this.totalPlaces < this.totalStations) { //a station was selected
                                let station = this.sortedStations[this.preselectIndex - this.totalPlaces];
                                this.selectStation(station);
                                this.$emit('station-selected');
                            }
                        }
                    }
                }
            },
            initPreselectIndex() {
                this.preselectIndex = -1;
                // if we have a selected station, set the index to that one
                if (this.selectedStation) {
                    var selectedStationIndex = this.sortedStations.findIndex((s) => s == this.selectedStation);
                    if (selectedStationIndex != -1) {
                        this.preselectIndex = selectedStationIndex + this.totalPlaces;
                    }
                }
            }
        },
        components: {
            ResultListStation,
            ResultListPlace,
            PdfDownloadButton
        }
    };
</script>